import { LifeBuoy } from 'lucide-react';
import { useEffect } from 'react';
import './tailwind.css';

const VapingResources = () => {
  useEffect(() => {
    // Function to send height to parent window
    const sendHeight = () => {
      // Get the full content height
      const height = document.getElementById('container').scrollHeight;
      
      // Send to parent window using postMessage
      if (window.parent && window.parent !== window) {
        console.log('Sending postMessage with height:', height);
        window.parent.postMessage({ height: height, type: 'resize' }, '*');
        // Also support simple number format
        window.parent.postMessage(height, '*');
      }
    };

    // Send height on initial load
    sendHeight();
    
    // Send height when window loads
    window.addEventListener('DOMContentLoaded', sendHeight);

    // Use ResizeObserver for dynamic content changes
    let resizeObserver;
    let intervalId;
    
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(() => {
        sendHeight();
      });
      resizeObserver.observe(document.body);
    } else {
      // Fallback: check periodically
      intervalId = setInterval(sendHeight, 500);
    }

    // Also send on DOM mutations
    let mutationObserver;
    if (window.MutationObserver) {
      mutationObserver = new MutationObserver(() => {
        sendHeight();
      });
      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }

    // Cleanup
    return () => {
      window.removeEventListener('load', sendHeight);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      if (mutationObserver) {
        mutationObserver.disconnect();
      }
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []);

  return (
    <div id="container" className="m-5">
      <div className="border-2 border-pink-500 shadow-xl rounded-lg p-4">
        <div className="flex items-center gap-3 mb-2">
          <LifeBuoy className="text-pink-500 w-9 h-9" />
          <h3 className="text-pink-500 my-auto font-sans text-xl font-semibold">Resources</h3>
        </div>

        <p className="font-serif">If you are struggling with vaping, help is available. Please consider taking advantage of the following resources or reaching out to your Latin counselor if you are a current student.</p>

        <div className="mt-3 grid grid-cols-1 md:grid-cols-4 gap-3">
          <a href="https://preventioned.org" target="_blank" rel="noopener noreferrer" className="h-32 bg-gradient-to-b from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 text-white font-semibold flex flex-col items-center justify-center p-4 transition-all duration-300">
            <div className="text-center text-lg mb-1">Prevention Education Solutions</div>
            {/* <div className="text-sm font-normal text-center opacity-90">Evidence-based prevention programs and educational resources</div> */}
          </a>

          <a href="https://www.hazeldenbettyford.org" target="_blank" rel="noopener noreferrer" className="h-32 bg-gradient-to-b from-indigo-500 to-indigo-700 hover:from-indigo-600 hover:to-indigo-800 text-white font-semibold flex flex-col items-center justify-center p-4 transition-all duration-300">
            <div className="text-center text-lg mb-1">Hazelden Betty Ford</div>
            {/* <div className="text-sm font-normal text-center opacity-90">Leading nonprofit treatment and recovery services</div> */}
          </a>

          <a href="https://www.rosecrance.org" target="_blank" rel="noopener noreferrer" className="h-32 bg-gradient-to-b from-violet-500 to-violet-700 hover:from-violet-600 hover:to-violet-800 text-white font-semibold flex flex-col items-center justify-center p-4 transition-all duration-300">
            <div className="text-center text-lg mb-1">Rosecrance</div>
            {/* <div className="text-sm font-normal text-center opacity-90">Comprehensive behavioral health and addiction treatment</div> */}
          </a>

          <a href="https://www.samhsa.gov/substance-use/learn/tobacco-vaping" target="_blank" rel="noopener noreferrer" className="h-32 bg-gradient-to-b from-purple-500 to-purple-700 hover:from-purple-600 hover:to-purple-800 text-white font-semibold flex flex-col items-center justify-center p-4 transition-all duration-300">
            <div className="text-center text-lg mb-1">SAMHSA Tobacco & Vaping</div>
            {/* <div className="text-sm font-normal text-center opacity-90">Federal resources on tobacco and vaping prevention</div> */}
          </a>
        </div>
      </div>
    </div>
  );
};

export default VapingResources;